import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Report Stimulus controller errors to Sentry (when available)
application.handleError = (error, message, detail) => {
  if (window.Sentry) {
    const tags = { identifier: detail?.identifier }
    const extra = { message }
    window.Sentry.captureException(error, { tags, extra })
    const errorInfo = `Error ID: ${window.Sentry.lastEventId()}`
    console.error("%s\n\n%s\n\n%o\n\n%o", message, errorInfo, error, detail)
  } else {
    console.error("%s\n\n%o\n\n%o", message, error, detail)
  }
}

export { application }
